import cronstrue from "cronstrue";

/**
 * Turn a 5-field cron (what the scheduler stores) into plain English. If parsing fails, show the
 * raw expression. Use `title` on the cell so operators can still see the exact cron.
 */
export function formatCronForDisplay(expression: string | null | undefined): { label: string; title: string } {
  const trimmed = expression?.trim() ?? "";
  if (trimmed === "") {
    return { label: "—", title: "No schedule" };
  }
  try {
    const label = cronstrue.toString(trimmed, {
      use24HourTimeFormat: false,
      dayOfWeekStartIndexZero: true,
    });
    return { label, title: `Cron: ${trimmed}` };
  } catch {
    return { label: trimmed, title: trimmed };
  }
}
